import type { TFunction } from 'i18next';
import { bool, object, string } from 'yup';

import { makePhoneNumber, makeTerms } from 'src/shared/validationSchemas';

const makeValidationSchema = (t: TFunction) =>
  object().shape({
    company: string().required(t('companyIsRequired')),
    familyName: string().required(t('lastNameIsRequired')),
    givenName: string().required(t('firstNameIsRequired')),
    mobilePhone: makePhoneNumber(t),
    hasAgreedToTerms: makeTerms(t),
    contactPolicy: object().optional().shape({
      hasConsent: bool().optional(),
    }),
  });

const makeValidationSchemaWithBranch = (t: TFunction) =>
  makeValidationSchema(t).concat(
    object().shape({
      branch: string().required(t('beacon.homeBranchIsRequired')),
    }),
  );

export { makeValidationSchema, makeValidationSchemaWithBranch };
